import _styled, { css } from "styled-components";
import { Col, Container, Row, Skeleton } from "@crehana/ui";
import { useLearnLastActivityContext } from "../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var PremiumTrialBannerSkeleton = function PremiumTrialBannerSkeleton(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'];
  var _useLearnLastActivity = useLearnLastActivityContext(),
    isDark = _useLearnLastActivity.isDark,
    containerType = _useLearnLastActivity.containerType;
  return /*#__PURE__*/_jsx(Container, {
    className: className,
    type: containerType,
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Row, {
      nowrap: true,
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(_StyledSkeleton, {
          className: "w-full rounded-5"
          // @ts-ignore
          ,

          isDark: isDark
        })
      })
    })
  });
};
export default PremiumTrialBannerSkeleton;
var _StyledSkeleton = /*#__PURE__*/_styled(Skeleton).withConfig({
  componentId: "sc-xeenbk-0"
})(["\n              height: 434px;\n              ", " {\n                height: 264px;\n              }\n              ", " {\n                height: 254px;\n              }\n            "], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('sm');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up('md');
});